import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const DashboardPage = withSuspense(
	lazy(async () => await import('./dashboard-page.component')),
	PageLoader,
);
